import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useChatStore } from '../../stores/chatStore';
import { useChatContext } from '../../contexts/ChatContext';

/**
 * Floating chat button - Enhanced with global unread count
 * Premium design, mavi gradient, animated badge
 */
export function FloatingChatButton() {
    const { isOpen, openChat } = useChatStore();
    const { unreadCount } = useChatContext();
    const location = useLocation();

    // Don't show if:
    // 1. Chat modal is open
    // 2. We are on the full-screen inbox page
    // 3. We are on the Image page
    if (isOpen || location.pathname.startsWith('/inbox') || location.pathname.startsWith('/img/')) return null;

    return (
        <AnimatePresence>
            <motion.button
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0, opacity: 0 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => openChat()}
                className="fixed bottom-6 right-6 z-50 hidden lg:flex items-center justify-center w-14 h-14 bg-gradient-to-br from-mavi-500 to-mavi-600 text-white rounded-full shadow-lg hover:shadow-xl transition-shadow"
                aria-label="Mesajlar"
            >
                {/* Unread badge with pulse animation */}
                {unreadCount > 0 && (
                    <>
                        {/* Pulse ring */}
                        <motion.div
                            className="absolute w-full h-full rounded-full bg-mavi-500"
                            animate={{
                                scale: [1, 1.4, 1.4, 1, 1],
                                opacity: [0.7, 0, 0, 0, 0.7],
                            }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut",
                            }}
                        />

                        {/* Badge */}
                        <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            className="absolute -top-1 -right-1 flex items-center justify-center min-w-[20px] h-5 px-1.5 bg-kirmizi-500 text-white text-xs font-bold rounded-full border-2 border-white shadow-md"
                        >
                            {unreadCount > 9 ? '9+' : unreadCount}
                        </motion.div>
                    </>
                )}

                {/* Icon */}
                <MessageCircle className="w-6 h-6" strokeWidth={2} />
            </motion.button>
        </AnimatePresence>
    );
}
